import type { SearchTasksResponse } from '@urbanx/agx.activities.client'
import type { InfiniteData } from '@tanstack/react-query'
import type { TaskUpdatedNotification } from 'types/pushNotifications'
import { applyTaskUpdateToTask } from 'utils/tasks/taskUpdates'
import type { TaskFilterState } from './TaskFilters/TaskFiltersState'

export const taskSearchQueryRoot = ['searchAllTasks'] as const

export const createTaskSearchQueryKey = (filters?: TaskFilterState) =>
  [...taskSearchQueryRoot, filters] as const

export type TaskSearchData = InfiniteData<
  SearchTasksResponse,
  string | undefined
>

export const applyTaskUpdateToSearchData = (
  data: TaskSearchData,
  taskUpdate: TaskUpdatedNotification
) => {
  let taskWasUpdated = false

  const pages = data.pages.map((page) => ({
    ...page,
    tasks: page.tasks?.map((task) => {
      if (task.id !== taskUpdate.task.id) return task

      taskWasUpdated = true
      return applyTaskUpdateToTask(task, taskUpdate)
    }),
  }))

  return {
    data: taskWasUpdated ? { ...data, pages } : data,
    requiresRefresh: taskUpdate.collectionStateChanged,
  }
}
